import { render, staticRenderFns } from "./SetupOrderData.vue?vue&type=template&id=18cb60ae&"
import script from "./SetupOrderData.vue?vue&type=script&lang=js&"
export * from "./SetupOrderData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports